/**
 * Mindarc Out of Stock Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/ma-app-out-of-stock.liquid
 *
 */
import $ from 'jquery';
import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

const apiEndpoints = {
    dev: 'https://shopifyoutofstockapp-dev.testarc.com.au',
    prod: 'https://shopifyoutofstockapp.testarc.com.au'
};

function getApiEndpoint() {
    return window.location.hostname == 'white-fox-boutique-develop.myshopify.com' ? apiEndpoints.dev : apiEndpoints.prod;
}

Vue.use(Vuelidate);

Vue.component('ma-app-out-of-stock', {
    props: ['currentVariant'],
    data() {
        return {
            isSubmitting: false,
            isSuccess: false,
            serverMessage: null,
            activeVariant: null,
            form: {
                email: null,
                variant_id: this.currentVariant.id,
            }
        }
    },
    watch:{
        currentVariant: function(newVal, oldVal){
            this.form.variant_id = newVal.id;
        }
    },

    validations: {
      form: {
        email: {
          required,
          email
        }
      }
    },

    methods: {
        submitForm (e) {

            // console.log('submit form', e);
            // console.log('vuelidator', this.$v);

            this.$v.$touch();

            if (!this.$v.$error) {
                // console.log('form is valid');
                this.isSubmitting = true;

                // console.log('form', this.form);
                // @TODO: Add axios post call to the MindArc app and handle response correctly, remove setTimeout
                // setTimeout(() => {
                //     this.isSuccess = true;
                // }, 400);

                axios.post(`${getApiEndpoint()}/subscriptions/api/subscribe?shop=${Shopify.shop}`, this.form )
                .then((response) => {
                    // console.log(response);
                    this.isSuccess = true;

                }).catch((error) => {
                    console.log(error);
                    this.serverMessage = error.data;

                }).finally(() => {
                    this.isSubmitting = false;
                });

            } else {
                console.log('form is invalid');
            }
        }
    },
    mounted(){

    
        // this.form.variant_id = this.currentVariant.id;


    }
});
